import type { Form, Rate as RateAD } from 'antd';
import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { Rate } from '../../rate';
import { Item } from '../item';

type InputP = ComponentProps<typeof RateAD>;

type ItemP = {
  hidden?: boolean;
  label?: string;
} & Omit<ComponentProps<typeof Form.Item>, 'children' | 'label'>;

type P = {
  input?: InputP;
  item: ItemP;
};

const RateInput = ({ input, item: { label, rules, ...itemRest } }: P) => {
  const { t } = useTranslation();
  const requiredRule = rules?.find((rule) => typeof rule === 'object' && rule.required);

  let newRules = rules;

  // When clicking on a rating star and then clicking on the same star again, the star appears empty, but this status isn't evaluated as empty. Therefore, we need to implement a custom rule to check if the rating is empty.
  if (newRules && requiredRule) {
    newRules = newRules.filter((rule) => requiredRule !== rule);
    newRules.push({
      async validator(_, value) {
        // eslint-disable-next-line no-template-curly-in-string -- Antd interface inserts template strings
        return value >= 1 ? Promise.resolve() : Promise.reject(new Error(t('Error: ${label} cannot be empty')));
      },
      // eslint-disable-next-line @typescript-eslint/no-misused-spread -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
      ...requiredRule,
    });
  }

  return (
    <Item {...itemRest} label={label} rules={newRules}>
      <Rate {...input} />
    </Item>
  );
};

export default RateInput;
